import React from 'react'
import dashstack from '../assets/logo.png'

const Logo = () => {
    return (
        <div>
            <img src={dashstack}/>
        </div>
    )
}

export default Logo